import { createActionGroup, emptyProps, props } from '@ngrx/store';

/**
 * Actions for avatar notification modal feature.
 *
 * @exports
 */
export const AvatarNotificationModalActions = createActionGroup({
  source: 'AvatarNotificationModal',
  events: {
    // Check if modal should show
    'Check Should Show': emptyProps(),
    'Check Should Show Success': props<{
      shouldShow: boolean;
      reason: string;
    }>(),
    'Check Should Show Failed': props<{ error: string }>(),

    // Record interaction
    'Record Interaction': props<{ action: string }>(),
    'Record Interaction Success': props<{ data: any }>(),
    'Record Interaction Failed': props<{ error: string }>(),

    // Modal state
    'Set Modal Open': props<{ isOpen: boolean }>(),
    'Reset State': emptyProps()
  }
});
